// extracted by mini-css-extract-plugin
export default {"customCard":"Card_customCard__+S5vO"};